import { Injectable } from '@angular/core';
import { DescriptionAiService, SAPRequest } from 'app/ai';
import { OrgNavigationService } from 'app/services/org-nav.service';
import { Observable, of } from 'rxjs';
import { TaskProcessService } from './task-process.service';
import { ProcessService } from '../bp-management/process.service';

@Injectable({
    providedIn: 'root',
})
export class DescriptionAiApiService {
    constructor(
        private orgNavigationService: OrgNavigationService,
        private processService: ProcessService,
        private taskProcessService: TaskProcessService,
        private api: DescriptionAiService
    ) {}

    public generateDescription(): Observable<string> {
        const taskId = this.orgNavigationService.url.split('/').pop();

        const process = this.processService.selectedProcess();
        const task = this.taskProcessService.model().tasks.find(t => t.id === taskId);

        if (!process || !task) {
            return of('fail');
        }
        const request: SAPRequest = {
            business_domain: process.area,
            goal: process.description,
            technology: task.data.action.systemInfo['title'],
            transaction: `${task.data.info['tcode']} - ${task.data.info['name']}`,
            result: task.data.output?.map(t => t.description).join(', '),
            required_information: task.data.input?.map(t => t.description).join(', '),
        };

        return this.generateDescriptionGenerateDescriptionPost(request);
    }

    private generateDescriptionGenerateDescriptionPost(request: SAPRequest): Observable<string> {
        return this.api.generateDescriptionGenerateDescriptionPost(request);
    }
}
